/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shot_Change_Offset_HelpInputs */



/**
* | output |
* | --- |
* | "Offset from shot change in frames" |
*
* @param {Shot_Change_Offset_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shot_change_offset_help = /** @type {((inputs?: Shot_Change_Offset_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shot_Change_Offset_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Décalage par rapport au changement de plan en images")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verschiebung durch Szenenwechsel in Frames")
	if (locale === "it") return /** @type {LocalizedString} */ ("Offset dal cambio di inquadratura nei fotogrammi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Смещение из-за смены кадра")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desplazamiento del cambio de toma en los fotogramas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("镜头切换引起的偏移量")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フレーム内のショット変更からのオフセット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ्रेम में शॉट परिवर्तन से ऑफसेट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Deslocamento da mudança de enquadramento em frames")
	return /** @type {LocalizedString} */ ("Offset from shot change in frames")
});